import React from "react";
import { NavLink } from "react-router-dom";
import * as Icons from "lucide-react";

interface MenuItemProps {
  item: {
    name: string;
    icon: string;
    path: string;
  };
  onMobileClose: () => void;
}

const MenuItem: React.FC<MenuItemProps> = ({ item, onMobileClose }) => {
  const IconComponent = (Icons as any)[item.icon] || Icons.HelpCircle;
  const isExact = item.path === "/dashboard/home";

  return (
    <NavLink
      to={item.path}
      onClick={onMobileClose}
      end={isExact}
      className={({ isActive }) =>
        `group relative flex items-center gap-3 rounded-md px-2 py-1.5 text-sm font-medium transition-all duration-200
        ${isActive
          ? "bg-white/10 text-white"
          : "text-gray-300 hover:bg-white/5 hover:text-white"
        }`
      }
    >
      {({ isActive }) => (
        <>
          <IconComponent
            size={16}
            className={`transition-all duration-200 ${isActive ? "text-primary" : "text-white/85 group-hover:text-white"
              }`}
          />
          <span className={`flex-1 ${isActive ? "text-primary" : "text-white/85 group-hover:text-white"
            }`}>{item.name}</span>
          {isActive && (
            <div className="w-1.5 h-1.5 rounded-full bg-primary shadow-[0_0_6px_#16f19e]" />
          )}
        </>
      )}
    </NavLink>
  );
};

export default MenuItem;